import React from "react";
import { Flex } from "@xometry/xometry_loft";
import FancyDownloadIllustration from "./images/FancyDownloadIllustration.svg";
import { fancyDownload } from "./FileShare.style";

const FancyDownload = ({ percentComplete }: { percentComplete: number }) => {
  return (
    <Flex css={fancyDownload} flexDirection="column">
      <div>
        <img src={FancyDownloadIllustration} alt="downloading" />
      </div>
      <div className="title">Downloading ({percentComplete}%)...</div>
      <div className="subtitle">
        Shared files are downloading. This may take a few moments.
      </div>
    </Flex>
  );
};

export default FancyDownload;
